import React, { useEffect, useState } from 'react';
import './EmployeeStats.css';
import Chart from 'chart.js/auto';

const InfoTable = () => {
  const [data, setData] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [showEmployeeStats, setShowEmployeeStats] = useState(false);

  useEffect(() => {
    // Fetch employee data
    fetch('https://hfstaff.com/api/admin/employee')
    // fetch('http://localhost:8082/api/admin/employee')
      .then(res => res.json())
      .then(data => setData(data))
      .catch(err => console.log(err));
  }, []);

  const handleShowEmployeeStats = (employeeId) => {
    // For demo purposes, you can set dummy stats here
    // Replace this with actual logic to fetch employee stats
    const selected = data.find(employee => employee.employee_id === employeeId);
    setSelectedEmployee(selected);
    setShowEmployeeStats(true);
    document.body.classList.add('blur-background');
  };

  const handleCloseModal = () => {
    setShowEmployeeStats(false);
    setSelectedEmployee(null);
    document.body.classList.remove('blur-background');
  };

  useEffect(() => {
    // Render charts when employee stats modal is shown
    if (showEmployeeStats && selectedEmployee) {
      renderCharts();
    }
  }, [showEmployeeStats, selectedEmployee]);

  const renderCharts = () => {
    // Dummy data for charts (replace with actual employee stats)
    const ctx = document.getElementById('salesChart').getContext('2d');
    new Chart(ctx, {
      type: 'bar',
      data: {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [{
          label: 'Sales',
          data: [120, 100, 150, 80, 200, 180, 220],
          backgroundColor: 'rgba(54, 162, 235, 0.2)',
          borderColor: 'rgba(54, 162, 235, 1)',
          borderWidth: 1
        }]
      },
      options: {
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }
    });
  };

  return (
    <div className="info-table-container">
      {selectedEmployee && showEmployeeStats && (
        <div className="modal-stat">
          <button className="modal-stat-close" onClick={handleCloseModal}>&times;</button>
          <div className="stat-content">
            <h2>Employee Stats</h2>
            <div className="stat-details">
              <p><strong>ID:</strong> {selectedEmployee.employee_id}</p>
              <p><strong>Name:</strong> {selectedEmployee.name}</p>
              <canvas id="salesChart" width="400" height="200"></canvas>
              {/* Add more charts or stats here */}
            </div>
          </div>
        </div>
      )}

      <div className="info-table-container">
        <div className={showEmployeeStats ? 'blur-background' : ''}>
          <table className="info-table">
            <thead>
              <tr>
                <th>Employee</th>
                <th>ID</th>
                <th>NAME</th>
                <th>Employee Stats</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map(employee => (
                  <tr key={employee.employee_id}>
                    <td><img src={employee.photo} alt="Employee" className="employee-photo" /></td>
                    <td>{employee.employee_id}</td>
                    <td>{employee.name}</td>
                    <td>
                      <button className='viewStats' onClick={() => handleShowEmployeeStats(employee.employee_id)}>View Stats</button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="loading-row">
                  <td colSpan="5">Loading...</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default InfoTable;
